import React, { useState, useEffect } from "react";
import "./evidencias.css";
import data from "../../json/cievidenciasitems";

const Evidencias = () => {

  // Estado para controlar qué sección del acordeón está abierta
  const [activo, setActivo] = useState(null);

  // Al cargar la página, posiciona el scroll arriba
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Función para abrir/cerrar acordeón
  const toggleAcordeon = (index) => {
    setActivo(activo === index ? null : index);
  };

  return (
    <div
      className="container-full-width evidencias-bg"
      style={{
        backgroundImage: `url(${data.background})`,
        backgroundSize: "30%",
        backgroundPosition: "center",
        backgroundRepeat: "repeat",
        width: "100%",
        minHeight: "100vh"
      }}
    >

      {/* =============================== */}
      {/* 1️⃣ TÍTULO */}
      {/* =============================== */}
      <h3 className="title">
        Evidencias
      </h3>
      <hr className='hr-gob' />

      {/* =============================== */}
      {/* 2️⃣ LINKS SUPERIORES */}
      {/* =============================== */}
      <div className="subheader-links">
        {data.links?.map((link, index) => (
          <a key={index} href={link.url} className="link-custom">
            {link.texto}
          </a>
        ))}
      </div>

     

      {/* =============================== */}
      {/* 4️⃣ ACORDEÓN */}
      {/* =============================== */}
      <div className="acordeon-container">

        {data.acordeon?.map((item, index) => (
          <div key={index} className="acordeon-item">

            {/* TÍTULO */}
            <div
              className="acordeon-titulo"
              onClick={() => toggleAcordeon(index)}
            >
              {item.titulo}
              <span>{activo === index ? "−" : "+"}</span>
            </div>

            {/* CONTENIDO */}
            <div
              className={
                activo === index
                  ? "acordeon-contenido abierto"
                  : "acordeon-contenido"
              }
            >
              {item.archivos?.map((archivo, i) => (
                <a
                  key={i}
                  href={archivo.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-pdf"
                >
                  📄 {archivo.nombre}
                </a>
              ))}
            </div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default Evidencias;